import PreferenceActions from 'actions/PreferenceActions';
import { AA, Resource, Method } from 'sdk';

class PreferenceActionCreator {
  updatePreference(customerId, params) {
    PreferenceActions.updateStarted();
    AA.api(Resource.preferences(customerId), Method.put, params).then((response) => {
      PreferenceActions.updateSucceeded(response.data);
    }, (error) => {
      PreferenceActions.updateFailed(error);
    });
  }
}

export default new PreferenceActionCreator();
